import React, { useState, useEffect } from "react";
import coin from "../assets/images/coin.png";
import celeb from "../assets/images/celeb.png";
import { Container } from "reactstrap";
import "./Transaction.css";
import { HttpService } from "./../../src/service/HttpService";
import moment from "moment-timezone";
import Header from "../Common/Header/Header";
import StarIcon from "@material-ui/icons/Star";
import  ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
const Transaction = (props) => {
  const [resultList, setResultList] = useState([]);
  const [user, setUser] = useState({});
  const httpService = new HttpService();
  var tz = moment.tz.guess();
  useEffect(() => {
    //  props.getUserInfo()
    getRecentTransaction();
    let obj = {};
    if (
      localStorage.getItem("user") !== undefined &&
      localStorage.getItem("user") !== null
    ) {
      obj = JSON.parse(localStorage.getItem("user"));
      setUser({ ...obj });
    }
  }, []);

  const getRecentTransaction = () => {
    httpService
      .getApi("user/transactionHistory")
      .then((response) => {
        setResultList(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getColor = (element) => {
    if (element.txType == "reward") return "green";
    else return "red";
  };

  return (
    <>
      <Header />
      <div className="transaction_sec">
        <Container>
          <div className="listings mt-5 mb-5">
            {resultList.map((element, i) => (
              //   let date;
              //   let time;

              //   if (element != undefined) {
              //       date = moment(element.createDate).format('DD MMM YYYY');
              //     time = moment(element.createDate).format("hh:mm:ss a")
              //   }

              <div className="list1 mb-3">
                <span className="sur">
                  <img src={celeb} alt="coin-imgg" />
                </span>
                <span style={{ textAlign: "center" }}>
                  {element.user != null &&
                  user.userId !== element.user.userId ? (
                    <p>
                      {element.user.firstName} {element.user.lastName}
                    </p>
                  ) : (
                    <p></p>
                  )}
                  <p>
                    {moment(element.createDate).format("DD MMM YYYY")}{" "}
                    <p style={{ fontSize: "12px" }}>
                      {moment(element.createDate).fromNow()}
                    </p>
                  </p>
                </span>
                <span className="coins" style={{ color: getColor(element) }}>
                  {" "}
                  <StarIcon style={{ color: "#EB7E1F", marginBottom: "5px" }} />
                  {parseInt(element.amount, 10)}
                </span>
              </div>
            ))}
          </div>
        </Container>
      </div>
    </>
  );
};
export default Transaction;
